<script>
export default {
  props: [
      'stackedWins', 'totalPossibleWins',
      'stackedBigTasks', 'totalPossibleBigTasks',
      'stackedSmallTasks', 'totalPossibleSmallTasks',
  ],
      // 'winsPercentage', 'bigTasksPercentage', 'smallTasksPercentage',
}
</script>

<template>
  <div class="d-flex justify-space-around text-center">

    <!-- wins -->
    <div>
      <v-progress-circular
          color="yellow-darken-1"
          :rotate="-120"
          :width="9"
          :size="100"
          :model-value="totalPossibleWins ? (stackedWins / totalPossibleWins)*100 : 0"
      >
        <template v-slot:default>
          <span v-if="totalPossibleWins" class="text-black">
            {{ stackedWins }} of {{ totalPossibleWins }}<br />
            stacked
          </span>
          <span v-else class="text-black">
            ZERO
          </span>
        </template>
      </v-progress-circular>
      <p class="pt-1 font-weight-bold">
        Wins <br />
        {{ totalPossibleWins ? `(${Math.round(100*stackedWins/totalPossibleWins) } %)` : '(0 %)'}}
      </p>
    </div>


    <!-- bigTasks -->
    <div>
      <v-progress-circular
          color="yellow-darken-1"
          :rotate="-120"
          :width="9"
          :size="100"
          :model-value="totalPossibleBigTasks ? (stackedBigTasks / totalPossibleBigTasks)*100 : 0"
      >
        <template v-slot:default>
          <span v-if="totalPossibleBigTasks" class="text-black">
            {{ stackedBigTasks }} of {{ totalPossibleBigTasks }}<br />
            stacked
          </span>
          <span v-else class="text-black">
            ZERO
          </span>
        </template>
      </v-progress-circular>
      <p class="pt-1 font-weight-bold">
        Big Tasks <br />
        {{ totalPossibleBigTasks ? `(${Math.round(100*stackedBigTasks/totalPossibleBigTasks)} %)` : '(0 %)'}}
      </p>
    </div>


    <!-- smallTasks -->
    <div>
      <v-progress-circular
          color="yellow-darken-1"
          :rotate="-120"
          :width="9"
          :size="100"
          :model-value="totalPossibleSmallTasks ? (stackedSmallTasks / totalPossibleSmallTasks)*100 : 0"
      >
        <template v-slot:default>
          <span v-if="totalPossibleSmallTasks" class="text-black">
            {{ stackedSmallTasks }} of {{ totalPossibleSmallTasks }}<br />
            stacked
          </span>
          <span v-else class="text-black">
            ZERO
          </span>
        </template>
      </v-progress-circular>
      <p class="pt-1 font-weight-bold">
        Small Tasks <br />
        {{ totalPossibleSmallTasks ? `(${Math.round(100*stackedSmallTasks/totalPossibleSmallTasks)} %)` : '(0 %)'}}
      </p>
    </div>


  </div>
</template>

<style scoped lang="scss">

</style>
